import { HttpInterceptorFn } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';

export const sellerAuthInterceptor: HttpInterceptorFn = (req, next) => {
    const platformId = inject(PLATFORM_ID);
    
    if (!isPlatformBrowser(platformId)) {
        return next(req);
    }
    
    let data:any=  localStorage.getItem("logedin-seller-child");
    if(!data) return next(req);
    data= JSON.parse(data);
  const sellerIdforChild = data?.seller?._id;
  const isChild = data?.child ? true :false;
  const childEmail = data?.child?.email;

  // Only modify for requests with body (POST/PUT/PATCH/DELETE)
  if (sellerIdforChild && req.body && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
    const modifiedReq = req.clone({
      body: {
        ...req.body,
        sellerIdforChild,
        isChild,
        childEmail
      }
    });
    return next(modifiedReq);
  }

  return next(req);
};
